import Ajax from "./ajax";

export default {
  // 考试结果页的info数据
  GETresultPageBycollegeId(param = {}) {
    return Ajax.get(`/api/examinee/v1/exam/resultPage/${param.collegeId}`, {
      ...param
    })
  },
  POSTresultList(param = {}) {
    return Ajax.post(`/api/examinee/v1/exam/resultList`, { ...param })
  }
};
